import { dmApi } from "../../app/dmApi";
import { serialize } from "../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";

export const staffAttendanceApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getStaffAttendanceList: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['staffAttendance'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getStaffAttendanceSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['staffAttendanceSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        markStaffAttendance: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/attendance/mark`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['staffAttendance', 'staffAttendanceSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Attendance")
            },
        }),
        getStaffAttendanceReportList: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance/report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['staffAttendanceReport'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
});

export const {
    useGetStaffAttendanceListQuery,
    useGetStaffAttendanceSummaryQuery,
    useMarkStaffAttendanceMutation,
    useGetStaffAttendanceReportListQuery,
} = staffAttendanceApi;